module.exports = __webpack_public_path__ + "static/media/145.32899258.jpg";